﻿export default class SkipButton {
  constructor() {
    this.id = 'skipRecommendation';
  }

  getHtml() {
    return `<button id="${this.id}" data-qa="skip-recommendations-button" class="btn btn--white btn--48-lg" data-skip-recommendations>Skip</button>`;
  }

  getNode() {
    return document.getElementById(this.id);
  }
}
